import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as r } from "../constants.js";
const s = (s2, t) => {
  const o = e({ reducerPath: "nodeSealTypesApi", baseQuery: t({ baseUrl: `${s2}/seal-types` }), keepUnusedDataFor: r, endpoints: (e2) => ({ getNodeSealTypes: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetNodeSealTypesQuery: u } = o;
  return { nodeSealTypesApi: o, useGetNodeSealTypesQuery: u };
};
export {
  s as initializeNodeSealTypesApi
};
//# sourceMappingURL=nodeSealTypesApi.js.map
